module.exports = function drawPoop(ctx) {
  ctx.save();
  ctx.fillStyle = 'rgba(0, 0, 0, 0)';
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(18, 0);
  ctx.lineTo(18, 18);
  ctx.lineTo(0, 18);
  ctx.closePath();
  ctx.clip();
  ctx.strokeStyle = 'rgba(0,0,0,0)';
  ctx.lineCap = 'butt';
  ctx.lineJoin = 'miter';
  ctx.miterLimit = 4;
  ctx.save();
  ctx.fillStyle = '#995243';
  ctx.globalAlpha = 0.8;
  ctx.beginPath();
  ctx.moveTo(5.449, 0);
  ctx.bezierCurveTo(5.449, 0, 6.842, 2.603, 9.21, 2.183);
  ctx.bezierCurveTo(9.375, 2.153, 9.534, 2.131, 9.685, 2.1149999999999998);
  ctx.translate(10.298035045701008, 5.222101065743173);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 3.167, -1.7655956307563185, 0.004704448757110846, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-10.298035045701008, -5.222101065743173);
  ctx.bezierCurveTo(13.465, 5.513, 13.429, 5.78, 13.363999999999999, 6.035);
  ctx.translate(12.28082155257508, 9.460839087148454);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 3.593, -1.2645632722304196, 0.5451577676855324, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-12.28082155257508, -9.460839087148454);
  ctx.translate(14.61316499362498, 14.621011550380446);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 3.379, -1.350057200443468, 1.5681816430299116, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-14.61316499362498, -14.621011550380446);
  ctx.lineTo(3.378, 18);
  ctx.translate(3.3736182456025494, 14.622002841885683);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 3.378, 1.5694991818492987, 4.488917795855039, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-3.3736182456025494, -14.622002841885683);
  ctx.translate(5.696605206394599, 9.461967455790333);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 3.594, 2.5956689895309397, 4.5687106221629605, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-5.696605206394599, -9.461967455790333);
  ctx.bezierCurveTo(4.194, 4.166, 4.375, 1.867, 5.45, 0);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.moveTo(8.595, 9.095);
  ctx.bezierCurveTo(
    8.595,
    10.315000000000001,
    7.603000000000001,
    11.304,
    6.381,
    11.304
  );
  ctx.translate(6.377999774777696, 9.093002035584698);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 2.211, 1.5694393724108913, 3.141141290202552, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-6.377999774777696, -9.093002035584698);
  ctx.bezierCurveTo(
    4.167,
    7.874000000000001,
    5.1579999999999995,
    6.886000000000001,
    6.381,
    6.886000000000001
  );
  ctx.bezierCurveTo(
    7.603,
    6.886000000000001,
    8.595,
    7.875000000000001,
    8.595,
    9.095
  );
  ctx.closePath();
  ctx.moveTo(13.804, 9.095);
  ctx.bezierCurveTo(
    13.804,
    10.315000000000001,
    12.812000000000001,
    11.304,
    11.59,
    11.304
  );
  ctx.translate(11.586999774777697, 9.093002035584698);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 2.211, 1.5694393724108913, 3.141141290202552, 0);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-11.586999774777697, -9.093002035584698);
  ctx.bezierCurveTo(
    9.376,
    7.874000000000001,
    10.366999999999999,
    6.886000000000001,
    11.59,
    6.886000000000001
  );
  ctx.bezierCurveTo(
    12.812,
    6.886000000000001,
    13.804,
    7.875000000000001,
    13.804,
    9.095
  );
  ctx.closePath();
  ctx.moveTo(11.455, 12.692);
  ctx.lineTo(11.455, 12.627);
  ctx.lineTo(6.8950000000000005, 12.627);
  ctx.lineTo(6.8950000000000005, 12.692);
  ctx.translate(9.175, 12.692);
  ctx.rotate(0);
  ctx.scale(1, 1);
  ctx.arc(0, 0, 2.28, 3.141592653589793, 0, 1);
  ctx.scale(1, 1);
  ctx.rotate(0);
  ctx.translate(-9.175, -12.692);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.save();
  ctx.fillStyle = '#311a12';
  ctx.beginPath();
  ctx.moveTo(6.395, 10.747);
  ctx.bezierCurveTo(
    7.2749999999999995,
    10.747,
    7.989999999999999,
    10.035,
    7.989999999999999,
    9.157
  );
  ctx.bezierCurveTo(
    7.989999999999999,
    8.277,
    7.276,
    7.5649999999999995,
    6.395,
    7.5649999999999995
  );
  ctx.bezierCurveTo(
    5.515,
    7.5649999999999995,
    4.800999999999999,
    8.277999999999999,
    4.800999999999999,
    9.155999999999999
  );
  ctx.bezierCurveTo(
    4.800999999999999,
    10.036,
    5.514999999999999,
    10.746999999999998,
    6.395,
    10.746999999999998
  );
  ctx.closePath();
  ctx.moveTo(11.577, 10.747);
  ctx.bezierCurveTo(12.457, 10.747, 13.171, 10.035, 13.171, 9.157);
  ctx.bezierCurveTo(
    13.171,
    8.277,
    12.456999999999999,
    7.5649999999999995,
    11.577,
    7.5649999999999995
  );
  ctx.bezierCurveTo(
    10.697,
    7.5649999999999995,
    9.982,
    8.277999999999999,
    9.982,
    9.155999999999999
  );
  ctx.bezierCurveTo(
    9.982,
    10.036,
    10.696,
    10.746999999999998,
    11.577,
    10.746999999999998
  );
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.restore();
  ctx.restore();
};
